module.exports = __webpack_public_path__ + "img/Birthday.67d04658.svg";